/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from 'react';
import { createPortal } from 'react-dom';
import { VideoInfo } from '../data/dataType';
import { HiMinusCircle, HiPlusCircle } from 'react-icons/hi2';
import { FaFileVideo } from 'react-icons/fa';
import Modal from './Modal';
import { AttributesInput } from './AttributesInput';
import { videoFields } from '../../app/[locale]/admin/lib/videoFields';
import {
    getNewPosition,
    setFieldValues,
    sortAscBy,
} from '../../app/[locale]/admin/lib/util';
import { v4 } from 'uuid';
import { FormikValues } from 'formik';
import VideoPlayer from '@/components/Gallery/VideoPlayer';

export const VideosInput: React.FC<{
    locale: string;
    value: VideoInfo[];
    onChange: (value: VideoInfo[]) => void;
}> = ({ locale, value, onChange }) => {
    const [videosInfo, setVideosInfo] =
        React.useState<(VideoInfo | undefined)[]>(value);

    const [attrEditing, setAttrEditing] = React.useState<string | undefined>(
        undefined,
    );

    const [_document, set_document] =
        React.useState<globalThis.Document | null>(null);

    React.useEffect(() => {
        set_document(document);
    }, []);

    const addVideo = () => {
        const initialValue = {
            id: v4(),
            name: '',
            title: { fr: '', en: '' },
            position: getNewPosition(videosInfo, 'position'),
        };
        const newValue = [...(value || []), initialValue];
        setVideosInfo(newValue);
    };

    const removeVideo = (videoInfo: VideoInfo) => {
        const newValue = [...value].filter(x => x.id !== videoInfo?.id);
        setVideosInfo(newValue);
        onChange(newValue);
    };

    const submitChanges = (value: FormikValues, videoInfo: VideoInfo) => {
        const newValue = setFieldValues(value, videoInfo, videoFields, locale);
        const newValues = [
            newValue,
            ...videosInfo.filter(f => f?.id !== videoInfo?.id),
        ];
        setVideosInfo(newValues);
        setAttrEditing(undefined);
        onChange(newValues);
    };

    return (
        <div>
            <div className="flex justify-end">
                <HiPlusCircle
                    className="h-10 w-10 fill-primary stroke-gray-900 border-gray-900 cursor-pointer"
                    onClick={addVideo}
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                {sortAscBy(videosInfo, 'position')?.map(
                    (videoInfo: VideoInfo) =>
                        videoInfo && (
                            <div key={videoInfo.id}>
                                <div className="flex justify-start">
                                    <FaFileVideo
                                        className="absolute mt-3 ml-2 h-8 w-8 fill-primary stroke-gray-900 border-gray-900 cursor-pointer"
                                        onClick={() =>
                                            setAttrEditing(videoInfo.id)
                                        }
                                    />
                                </div>
                                <div className="flex justify-end">
                                    <HiMinusCircle
                                        className="absolute mt-2 mr-1 h-10 w-10 fill-primary stroke-gray-900 border-gray-900 cursor-pointer"
                                        onClick={() => removeVideo(videoInfo)}
                                    />
                                </div>
                                <div className="flex p-2">
                                    {_document &&
                                        createPortal(
                                            <Modal
                                                opacity={40}
                                                showModal={
                                                    attrEditing === videoInfo.id
                                                }
                                            >
                                                <AttributesInput
                                                    attributes={videoInfo}
                                                    fields={videoFields}
                                                    locale={locale}
                                                    onCancel={() =>
                                                        setAttrEditing(
                                                            undefined,
                                                        )
                                                    }
                                                    onSubmitChanges={(
                                                        value: FormikValues,
                                                    ) =>
                                                        submitChanges(
                                                            value,
                                                            videoInfo,
                                                        )
                                                    }
                                                    title="Vidéo info"
                                                />
                                            </Modal>,
                                            _document.body,
                                        )}
                                    <VideoPlayer url={videoInfo.url} />
                                </div>
                            </div>
                        ),
                )}
            </div>
        </div>
    );
};
